import { render, staticRenderFns } from "./TabSwitcher.vue?vue&type=template&id=171b8664&scoped=true&"
import script from "./TabSwitcher.vue?vue&type=script&lang=js&"
export * from "./TabSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./TabSwitcher.vue?vue&type=style&index=0&id=171b8664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171b8664",
  null
  
)

export default component.exports